/**
 * @module bloodGroups
 * @description A list of bloodGroups
 */
export const bloodGroups: string[] = [
	'A+',
	'A-',
	'B+',
	'B-',
	'AB+',
	'AB-',
	'O+',
	'O-'
  ]
